export const EventPrefix:string = "eo-event-"

export const YearFilterDrawerOpen = "year-filter-drawer-open"
export const YearFilterDrawerClose = "year-filter-drawer-close"
export const YearFilterDrawerClosed = "year-filter-drawer-closed"

export const CurrencySelectDrawerOpen = "currency-select-drawer-open"
export const CurrencySelectDrawerClosed = "currency-select-drawer-closed"

export const FloorSelectorDrawerOpen = "floor-selector-drawer-open"
export const FloorSelectorDrawerClosed = "floor-selector-drawer-closed"

export const FloorSelected = "floor-selected"